import { Disclosure } from 'api/lender/getLenderDisclosures'
import DisclosureType from 'state/enums/DisclosureType'

export const DISCLOSURE_LOAD_ERROR_MESSAGE =
    'Required disclosures could not be loaded. Submission is disabled until all disclosures are available. Please reload the page and try again.'

export function hasRequiredDisclosures(
    disclosures: Disclosure[] | undefined,
    requiredTypes: DisclosureType[],
): boolean {
    if (!disclosures?.length) {
        return false
    }

    return requiredTypes.every((type) =>
        disclosures.some(
            (disclosure) =>
                disclosure.name === type && disclosure.text?.trim().length > 0,
        ),
    )
}
